/* globals axios */

import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('poll-component', {
    props: {
        pollId: {
            type: String,
            default: null,
            required: true,
        },

        pollTotalVotes: {
            type: Number,
            default: 0,
        },

        answers: {
            type: Array,
            default: () => [],
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            vote: null,
            totalVotes: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.totalVotes = this.pollTotalVotes;
        this.getLocalStorage();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting || !this.vote) {
                return;
            }

            this.submitting = true;

            axios
                .post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result && result.data && result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    this.setLocalStorage();
                // this.scrollToTop();
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error.response);
                });
        },

        getLocalStorage() {
            const hasVoted = localStorage.getItem(this.pollId);

            if (!hasVoted) {
                return;
            }

            this.formCompleted = true;
            this.vote = hasVoted;
            this.setPercentage();
        },

        setLocalStorage() {
            localStorage.setItem(this.pollId, this.vote);

            this.totalVotes += 1;

            for (let i = 0; i < this.answers.length; i++) {
                if (this.vote === this.answers[i].id) {
                    this.answers[i].count += 1;
                }

                this.answers[i].percent = ((this.answers[i].count / this.totalVotes) * 100);
            }
        },

        setPercentage() {
            for (let i = 0; i < this.answers.length; i++) {
                this.answers[i].percent = ((this.answers[i].count / this.totalVotes) * 100);
            }
        },
    },
});
